import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditBadgeMasterPage = withSuspense(lazy(() => import('./edit-badges-master-page')));
export default EditBadgeMasterPage;
